import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';


class Delete extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.config.plan.tipos.delete}
                postUrl={api.proyectos.config.plan.tipos.delete}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Tipo de Transferencia ha sido eliminado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Eliminar Tipo de Transferencia"}
                buttonTitle={"Eliminar Tipo de Transferencia"}
                buttonIcon={"fa fa-trash fa-lg"}
                
                saveButton={true}
                closeButton={true}
                saveButtonLabel={"Eliminar"}
                buttonClass={"btn-danger"}
                danger={true}
            >
                <Row>
                    <Col className="col-2">
                        <Label>Nombre</Label>
                    </Col>
                    <Col className="col-10">
                        <Input type="text" name="nombre" disabled={true}></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Plan_Tipos/Delete.js